<script setup lang="ts">
import { definePageMeta, useHead } from '#imports';

definePageMeta({
   layout: 'wow-polo',
});

useHead({
   title: 'Tournaments — WOW Polo Series',
});
</script>

<template>
   <div>
      <!-- Hero -->
      <section class="wow-tournaments-hero relative h-[320px] bg-cover bg-center bg-no-repeat">
         <div class="absolute inset-0 bg-black/50" />
         <div class="relative flex h-full flex-col items-center justify-center px-6 text-center">
            <h1 class="mb-4 text-4xl font-bold text-white md:text-5xl lg:text-6xl">
               Tournaments
            </h1>
            <!-- Two lines on mobile, one on desktop, matching the homepage hero. Flex
                 rather than a hidden <br> so the word gap comes from gap-x-1 and does
                 not depend on template whitespace. -->
            <p class="flex max-w-xl flex-col items-center justify-center gap-x-1 text-lg text-white/90 md:flex-row">
               <span>Presented by</span>
               <span>The Brennan Family Foundation</span>
            </p>
         </div>
      </section>

      <div class="min-h-screen bg-gray-50 p-4">
         <div class="mx-auto max-w-7xl">
            <TournamentsPublicTournamentsTable :show-country-filter="false" />
         </div>
      </div>
   </div>
</template>

<style scoped>
.wow-tournaments-hero {
   background-image: url('/img/home-page-hero-bg.webp');
}
</style>
